export const featureIconMap = {
	new_feature: 'fak fa-solid-sparkles',
	improvement: 'fa-solid fa-chart-line-up',
	default: 'fa-solid fa-screwdriver-wrench',
};

export const featureColorMap: Record<string, 'warning' | 'success' | 'primary'> = {
	new_feature: 'warning',
	improvement: 'success',
	default: 'primary',
};

export enum FeatureType {
	NewFeature = 'new_feature',
	Improvement = 'improvement',
	BugFix = 'bug_fix',
}

export interface ReleaseFeature {
	type: FeatureType;
	title: string;
	description?: string;
	premium: boolean;
	experimental: boolean;
	linkText?: string;
	href?: string;
}

export interface ReleaseVersion {
	timestamp: number;
	appVersion: string;
	features: ReleaseFeature[];
}

export interface ChangelogVersionMeta {
	appVersion: string;
	timestamp: number;
	date: string;
}
